import React from "react";

const Footer = () => {
  return (
    <div className="footer grid-container">
        <div className="Side">
          <h2>Footer</h2></div>
          <div className="Main">
            <span className="footer-link">About</span>
            <span className="footer-link">FAQ</span>
            <span className="footer-link">Contact</span>
            <span className="footer-link">Terms of Service</span>
            <span className="footer-link">Privacy Policy</span>
            <span className="footer-link">Twitter</span>
            <span className="copyright">A project by Stanley &amp; Rox</span>
          </div>
    </div>
  );
};

export default Footer;
